import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import momentTimezone from 'moment-timezone';

moment.tz.setDefault("America/Sao_Paulo");

export function dateTimeFormat(dateTime) {
  return moment(dateTime).format('DD/MM/YY HH:mm');
}

export function dateFormat(dateTime) {
  return moment(dateTime).format('DD/MM/YY');
}

// Formats a span of seconds as a compact human duration: "2h 15min", "45min", "30s".
export function durationFromSeconds(seconds) {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  if (total === 0) {
    return '0min';
  }

  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);

  if (hours > 0) {
    return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
  }
  if (minutes > 0) {
    return `${minutes}min`;
  }
  return `${total}s`;
}
